import { render, staticRenderFns } from "./red_talent9.vue?vue&type=template&id=67a5248a&scoped=true"
import script from "./red_talent9.vue?vue&type=script&lang=js"
export * from "./red_talent9.vue?vue&type=script&lang=js"
import style0 from "./red_talent9.vue?vue&type=style&index=0&id=67a5248a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5248a",
  null
  
)

export default component.exports